import { ApiServiceV1 } from '@services/api.service';

export default {
  async getInputMessage({ suffix, id }) {
    const { data } = await ApiServiceV1.get(`${suffix}/input-message/${id}`);
    return data || {};
  },
  async getInputMessages({
    suffix, orderId = null, orderItemId = null, irSuccess = null,
    type = null, pageNum = 1, pageSize = 10,
  }) {
    const { data } = await ApiServiceV1.get(`${suffix}/input-message`, {
      params: {
        orderId, orderItemId, type, irSuccess, pageNum, pageSize,
      },
    });
    return data || {};
  },
};
